

const SettingsSWRKpisCharts = () => import('frontend/pages/settings/swa/SettingsSWRKpisCharts')
const SettingsSWRPage = () => import('frontend/pages/settings/swa/SettingsSWRPage')

import { CONFIGURATION_KEYS } from 'frontcore/constants/constants'
import { SETTINGS_CARDS_TOKENS } from 'frontend/constants/settings'
import { SWR_SOURCE } from 'frontend/constants/standardWorkReview'

export default [
  {
    configKeyForEnablingRoute: CONFIGURATION_KEYS.IS_CAPABILITY_TO_REACH_SWT_ENABLED,
    path: SETTINGS_CARDS_TOKENS.swrTolerance.name,
    name: SETTINGS_CARDS_TOKENS.swrTolerance.name,
    components: {
      default: SettingsSWRPage,
    },
    props: { default: { source: SWR_SOURCE } },
  },
  {
    path: SETTINGS_CARDS_TOKENS.settingsSWRKpis.name,
    name: SETTINGS_CARDS_TOKENS.settingsSWRKpis.name,
    components: {
      default: SettingsSWRKpisCharts,
    },
  },
]
